import { Component, Input, OnDestroy, OnInit, ViewEncapsulation, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { DecodedToken } from '@core/models';
import { AuthState } from '@ngxs-store/auth-store/auth.state';
import { ResetBrandAction } from '@ngxs-store/breadcrumb-store/breadcrumb.actions';
import { ClearSearchTextAction } from '@ngxs-store/search-store/search.actions';
import { Navigate } from '@ngxs/router-plugin';
import { Select, Store } from '@ngxs/store';
import { Observable, Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
@Component({
    selector: 'app-nav',
    templateUrl: './nav.component.html',
    styleUrls: ['./nav.component.css'],
    encapsulation: ViewEncapsulation.None
})
export class NavComponent implements OnInit, OnDestroy {
    @Input() isHomePage: boolean = false;
    @Input() searchText: string;
    @Select(AuthState.getDecodedToken) decodedToken$: Observable<DecodedToken>;

    navLinks = navLinks;
    routeSub: Subscription;
    noImageRole = false;
    hasValidToken = false;

    constructor(public store: Store, private activatedRoute: ActivatedRoute, private router: Router, private cdr: ChangeDetectorRef) {
        this.decodedToken$.subscribe(token => {
            this.noImageRole = token.roles.includes("NoImage");
            this.hasValidToken = this.store.selectSnapshot(AuthState.getHasValidToken);

            if (this.noImageRole && this.hasValidToken) {
                this.navLinks.push(noImageNavLink);
            }
        });
    }

    ngOnInit() {
        this.routeSub = this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
            this.navLinks.forEach((x) => x.linkedClass = "categories");

            const category = this.activatedRoute.snapshot.queryParams["category"]?.toLowerCase();
            if (category) {
                this.navLinks.find(x => x.name.toLowerCase() === category).linkedClass = "categories selected-category"
            }
        });

    }

    logoutRefresh() {
        this.cdr.detectChanges();
        this.navLinks = this.navLinks.filter(i => i !== noImageNavLink);
    }

    loginRefresh() {
        this.cdr.detectChanges();
        this.navLinks.push(noImageNavLink);
    }

    search() {
        // this.store.dispatch(new Navigate(['products/search', this.searchText]));
        this.router.navigate(
            ['products'],
            {
                queryParams: { searchText: this.searchText }
            }
        );
    }

    selectedCategory(event) {
        this.clearSearch();
        this.store.dispatch(new ResetBrandAction());
        const catergory = document.querySelectorAll('.selected-category');
        catergory.forEach(catergory => {
            catergory.classList.remove('selected-category');
        });
        event.srcElement.classList.add("selected-category");
        const nav = document.querySelectorAll('#responsive-nav');
        nav.forEach(nav => {
            nav.classList.remove('active');
        });
    }

    clearSearch() {
        this.store.dispatch(new ClearSearchTextAction());
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}

let noImageNavLink = {
    link: "/manage",
    linkedClass: "catagories",
    name: "No Images"
};

let navLinks = [

    {
        link: "/",
        linkedClass: "catagories",
        name: "Home"
    },

    {
        link: "/chips",
        linkedClass: "catagories",
        name: "Chips"
    },
    {
        link: "/chocolates",
        linkedClass: "catagories",
        name: "Chocolates"
    }
    , {
        link: "/liquor",
        linkedClass: "catagories",
        name: "Liquor"
    },
    {
        link: "/sweets",
        linkedClass: "catagories",
        name: "Sweets"
    },
    {
        link: "/beverages",
        linkedClass: "catagories",
        name: "Beverages"
    },

    {
        link: "/biscuits",
        linkedClass: "catagories",
        name: "Biscuits"
    }
    ,

    {
        link: "/hygiene",
        linkedClass: "catagories",
        name: "Hygiene"
    }
    ,
    {
        link: "/featured",
        linkedClass: "catagories",
        name: "FEATURED"
    }

]
